import { useQuery } from "@apollo/client";
import type { Organization } from "@casey/db-types";
import { GET_ORGANIZATION_ONBOARDING_STATUS } from "../gql";

interface TeamOnboardingStatusVariables {
  organizationSlug: string;
}

interface TeamOnboardingStatusResponse {
  organizationBySlug: Organization | null;
}

export function useOrganizationOnboardingStatus(organizationSlug: string) {
  const { data, loading, error, refetch } = useQuery<
    TeamOnboardingStatusResponse,
    TeamOnboardingStatusVariables
  >(GET_ORGANIZATION_ONBOARDING_STATUS, {
    variables: { organizationSlug },
    skip: !organizationSlug,
    errorPolicy: "all",
  });

  const organization = data?.organizationBySlug;
  const onboardingStatus = organization?.onboardingStatus;

  return {
    organization,
    onboardingStatus,
    loading,
    error,
    refetch,
  };
}
